import { formatNumber } from "utils/format";

/** "42.5%" for `part` of `whole`, "0%" when there is no denominator. */
export const formatRate = (part, whole) => {
  const denominator = Number(whole) || 0;
  if (denominator <= 0) return "0%";
  const ratio = ((Number(part) || 0) / denominator) * 100;
  return `${formatNumber(ratio, { maximumFractionDigits: 1 })}%`;
};

/** "Completed 42 of 168 sent". */
export const formatRatio = (verb, part, whole, noun) =>
  `${verb} ${formatNumber(part || 0)} of ${formatNumber(whole || 0)} ${noun}`.trim();

/** Seconds as "2m 10s" (or "45s" under a minute); "N/A" when unknown. */
export const formatDuration = (seconds) => {
  const total = Math.round(Number(seconds) || 0);
  if (total <= 0) return "N/A";
  const minutes = Math.floor(total / 60);
  const rest = total % 60;
  return minutes > 0 ? `${minutes}m ${rest}s` : `${rest}s`;
};
